import {
  type AltoIconName,
  type AltoIconNameWithColors,
  type ColorVariant,
  altoIconToUrlMap,
} from '@alto/design-library-tokens';
import * as React from 'react';
import { Image } from 'react-native';
import { INTERNAL_IconWrapper } from './INTERNAL_IconWrapper';
import { calculateIconPxSize } from './utils';

export type AltoIconProps = {
  readonly accessibilityLabel?: string;
  readonly allowFontScaling?: boolean;
  readonly name: AltoIconName;
  /**
   * Use for testing-library identification purposes, only if you can't rely on user-readable text or a11y labels.
   */
  readonly testID?: string;
  readonly type?: ColorVariant;
};

export const AltoIcon = ({ name, accessibilityLabel, type, allowFontScaling = true, testID }: AltoIconProps) => {
  const size = name.endsWith('-small') ? 'small' : 'regular';
  const sizePx = calculateIconPxSize(size, allowFontScaling);
  const iconName: AltoIconNameWithColors = type ? `${name}-${type}` : name;
  const uri = altoIconToUrlMap[iconName];

  return (
    <INTERNAL_IconWrapper
      allowFontScaling={allowFontScaling}
      size={size}
      testID={testID}
      accessibilityLabel={accessibilityLabel}
    >
      <Image
        source={{ uri }}
        style={{ width: sizePx, height: sizePx }}
      />
    </INTERNAL_IconWrapper>
  );
};
